<template>
    <div class="page-body md2019030601-xxw">
        <div class="container">
            <form class="layui-form" id="forms">
                <div class="box">
                    <div class="x-choose-down">
                        <div class="x-ipt-group" id="sel1">
                            <div style="min-height: 36px;">
                                <el-select v-model="value1" clearable placeholder="选择课程" style="width: 100%;">
                                    <el-option v-for="item in options1" :key="item.courseId" :label="item.courseName"
                                        :value="item.courseId">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="x-choose-down">
                        <div class="x-ipt-group" id="sel1">
                            <div style="min-height: 36px;">
                                <el-select v-model="value2" clearable placeholder="试题类型" style="width: 100%;">
                                    <el-option v-for="item in options2" :key="item.value" :label="item.name"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div @click="generateTest" class="form-btn form-btn-blue" style="color: white;font-weight: 600;">生成试题</div>
                </div>
            </form>
        </div>
        <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%" top="25vh">
            <el-input v-model="subjectCount" autocomplete="off" type="number"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmGenerateTest">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                queCount: 0,
                subjectCount: '',
                title: '',
                dialogFormVisible: false,
                value: '',
                options: [], //工种列表
                value1: '',
                options1: [],
                value2: '',
                options2: [{ value: '1', name: '客观题' }, { value: '2', name: '实操题' }],
                testType: 0
            }
        },
        created() {
            // 1模拟  2顺序练习
            this.testType = this.$route.params.testType;

            //加载工种数据
            this.laodCourseData();
        },
        methods: {
            confirmGenerateTest() {
                if (parseInt(this.subjectCount) > this.queCount) {
                    this.$message({
                        showClose: true,
                        message: '输入题量超出现有题量！'
                    });
                    return false;
                } else if (parseInt(this.subjectCount) > 200) {
                    this.$message({
                        showClose: true,
                        message: '模拟测试最多可选200道！'
                    });
                    return false;
                }
                if (this.testType == 1) {
                    this.$router.push({ name: 'mockTest', params: { courseId: this.value1, testQueNum: parseInt(this.subjectCount), queType: this.value2 } });
                } else {
                    this.$router.push({ name: 'exerciseSequence', params: { courseId: this.value1, testQueNum: parseInt(this.subjectCount), queType: this.value2 } });
                }
            },
            generateTest() {
                
                if (this.value1 == '') {


                    this.$message({
                        showClose: true,
                        message: '请选择课程'

                    });
                    return false;
                }



                let parames = new URLSearchParams();
                parames.append('courseId', this.value1);
                parames.append('queType', this.value2);




                console.log("工种    "+this.value + "课程   "+this.value1 + "试题类型   "+this.value2);

                this.$axios.post(this.serverUrl + '/ex/getQueCount', parames).then(resp => {

                    if (resp.data.queCount > 0) {
                        this.queCount = resp.data.queCount;
                        this.title = '查询到该工种下共有' + resp.data.queCount + '道试题，请输入试题数量';
                        this.dialogFormVisible = true;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '未查询到试题信息，请联系课程老师！'
                        });
                    }

                }).catch(err => {

                })



            },
           
            //加载课程数据
            laodCourseData() {

                let parames = new URLSearchParams();
                parames.append('userId', this.$storage.get('declareUser').id);

                let ArrayList = [];
                this.$axios.post(this.serverUrl + '/tm/getExpertPower', parames).then(resp => {

                    if (resp.data.code == 1) {
                        resp.data.data.forEach(element => {
                            let exam = {
                                courseId: 0,
                                courseName: 0
                            }
                            exam.courseId = element.courseId;
                            exam.courseName = element.courseName;

                            ArrayList.push(exam);
                        });
                        this.options1 = ArrayList;

                    }

                }).catch(err => {

                })

            }
            
        }

    }
</script>

<style scoped>
    .el-select-dropdown__item {
        font-size: 14px;
        padding: 0 20px;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #606266;
        height: 34px;
        line-height: 34px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        text-align: center;
    }

    div /deep/ .el-input__inner {
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
        text-align: center;
    }

    .form-btn {
        display: inline-block;
        padding: 5px 24px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        height: 32px;
    }

    .md2019030601-xxw .form-btn {
        margin-top: 0px;
        width: 100%;
        background: #29b2f7;
        border-radius: 0;
        border: none;
    }

    .x-choose-down .x-ipt-group {
        width: 340px;
        height: 40px;
        border-radius: 3px;
        padding-left: 8px;
        color: #999;
        background: #fff;
        display: inline-block;
        position: relative;
    }

    .md2019030601-xxw .x-choose-down .x-ipt-group {
        width: 100%;
        height: 38px;
        border-radius: 1px;
        color: #999;
        padding-left: 0;
    }

    .md2019030601-xxw .x-choose-down {
        margin-bottom: 30px;
    }

    .md2019030601-xxw .box {
        width: 348px;
        margin: 0 auto;
        padding-top: 190px;
    }

    .md2019030601-xxw {
        height: 890px;
        background: url(../../../static/img/bg_2019030601_xxw.jpg) no-repeat center;
        text-align: center;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }
</style>


// WEBPACK FOOTER //
// src/components/exercise/exercisePrepositionExpert.vue